import React, { useEffect, useState } from "react";
import { Paper, withStyles } from '@material-ui/core';
import MUIDataTable from "mui-datatables";
import { connect } from "react-redux";
import * as actions from "../../../actions/giftcardorder";
import FormDialogAddGiftcardorder from "../formDialog/FormDialogAddGiftcardorder";
import FormDialogEditGiftcardorder from "../formDialog/FormDialogEditGiftcardorder";
import FormDialogDeleteGiftcardorder from "../formDialog/FormDialogDeleteGiftcardorder";
import moment from "moment";
const styles = theme => ({
    paperTable: {
        padding: theme.spacing(0),
    }
})

const GiftcardorderTable = ({ classes, ...props }) => {
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(15)

    useEffect(() => {
        props.fetchPagination(1, rowsPerPage)
    }, [])

    const handleChangePage = async (newPage) => {
        await setPage(newPage);
        props.fetchPagination(newPage + 1, rowsPerPage)
    };

    const handleChangeRowsPerPage = async (rowsPerPage) => {
        await setRowsPerPage(rowsPerPage);
        await setPage(0);
        props.fetchPagination(1, rowsPerPage)
    };

    const handleSearch = async (searchText) => {
        await setPage(0);
        props.fetchPagination(1, rowsPerPage, searchText, searchText)
    };

    const handleFilterChange = async (title,description) => {
        await setPage(0);
        props.fetchPagination(1, rowsPerPage, title, description)
    };

    const refresh = async () => {
        await setPage(0);
        props.fetchPagination(1, rowsPerPage)
    }
    
    const columns = [
        {
            name: "id",
            label: "ID",
            options: {
                display: false,
                filter: false,
                sort: false,
            }
        },
        {
            
            name: "orderno",
            label: "Order no",
            options: {
                filter: true,
                sort: false,
            },
            
        },
        {
            
            name: "name",
            label: "Receiver's Name",
            options: {
                filter: true,
                sort: false,
            },
            
        },
        {
            
            name: "email",
            label: "Receiver's email",
            options: {
                filter: true,
                sort: false,
            },
            
        },
        {
            
            name: "mobile",
            label: "Receiver's mobile",
            options: {
                filter: true,
                sort: false,
            },
            
        },
        {
            
            name: "message",
            label: "Message",
            options: {
                filter: true,
                sort: false,
                display: false,
            },
            
        },
        {
            
            name: "sender",
            label: "sender",
            options: {
                filter: true,
                sort: false,
                display: false,
            },
            
        },
        {
            
            name: "amount",
            label: "Amount",
            options: {
                filter: true,
                sort: false,
            },
            
        },
        {
            
            name: "expiry",
            label: "expiry",
            options: {
                filter: true,
                sort: false,
                display: false,
            },
            
        },
        {
            
            name: "giftcard",
            label: "giftcard",
            options: {
                filter: true,
                sort: false,
                display: false,
            },
            
        },
        {
            
            name: "transactionNumber",
            label: "Transaction Number",
            options: {
                filter: true,
                sort: false,
               
            },
            
        },
        {
            
            name: "note",
            label: "note",
            options: {
                filter: true,
                sort: false,
                display: false,
            },
            
        },
        {
            
            name: "redeemptionStatus",
            label: "Redeemption Status",
            options: {
                filter: true,
                sort: false,
            },
            
        },
        {
            name: "createdOn",
            label: "Created on",
            options: {
                filter: true,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) =>  {
                    return moment(value).format('lll');
                }
            }
        },
      
        {
            name: "",
            options: {
                filter: false,
                sort: false,
                empty: true,
                customHeadRender: (columnMeta, handleToggleColumn) => {
                    return (
                        <th key={columnMeta.index} style={{paddingRight: "16px"}}>
                            <div style={{display:"flex", flexDirection:"row", justifyContent:"flex-end"}}>
                                {/* <FormDialogAddGiftcardorder component={Paper}  
                                    create={props.create}
                                    refresh={refresh}
                                /> */}
                            </div>
                        </th>
                    );
                },
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <div style={{display:"flex", flexDirection:"row", justifyContent:"flex-end"}}>
                            <FormDialogEditGiftcardorder
                                dataGiftcardorder={tableMeta.rowData}
                                update={props.update}
                            />
                            <FormDialogDeleteGiftcardorder 
                                dataGiftcardorder={tableMeta.rowData}
                                delete={props.delete}
                                refresh={refresh}
                            />
                        </div>
                    );
                }
            }
        }
    ];

    const options = {
        filter: false,
     
        filterType: 'textField',
        responsive: 'stacked',
        selectableRows: false,
        rowsPerPageOptions: [5, 10, 25],
        serverSide: true,
        viewColumns: false,
        print: false,
        download: false,

        rowsPerPage: rowsPerPage,
        count: props?.meta?.totalDocs || 0,
        page: page,

        onTableChange: (action, tableState) => {
            switch (action) {
              case 'changePage':
                handleChangePage(tableState.page)
                break;

            case 'changeRowsPerPage':
                handleChangeRowsPerPage(tableState.rowsPerPage)
                break;

            case 'search':
                handleSearch(tableState.searchText)
                break;

            case 'filterChange':
                handleFilterChange(tableState.filterList[1], tableState.filterList[2])
                break;
            
            case 'resetFilters':
                handleSearch("")
                break;
                 
              default:
                break;
            }
        },
    };
    
    return (
        <MUIDataTable className={classes.paperTable}
            data={props.giftcardorders}
            columns={columns}
            options={options}
        />
    );
}

const mapStateToProps = state => ({
    giftcardorders: state?.giftcardorder?.giftcardorders,
    meta: state?.giftcardorder?.metaGiftcardorder
})

const mapActionToProps = {
    fetchPagination: actions.Pagination,
    create: actions.create,
    update: actions.update,
    delete: actions.Delete
}

export default connect(mapStateToProps, mapActionToProps)(withStyles(styles)(GiftcardorderTable));